import { X } from 'lucide-react';
import { ReactNode } from 'react';
import { Button } from '../../ui/Button/Button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '../../ui/Dialog/Dialog';

interface Props {
  btnTitle: ReactNode;
  btnStyle?: string;
  modalTitle?: string;
  modalTitleStyle?: string;
  children?: React.ReactNode;
  isOpen?: boolean;
  onClose?: () => void;
}

export default function Modal({
  btnStyle,
  btnTitle,
  modalTitle,
  modalTitleStyle,
  children,
  isOpen,
  onClose,
}: Props) {
  // Handle Dialog's onOpenChange which receives a boolean
  const handleOpenChange = (open: boolean) => {
    if (!open && onClose) {
      onClose();
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={handleOpenChange}>
      {typeof isOpen === 'undefined' && (
        <DialogTrigger asChild>
          <Button className={btnStyle}>{btnTitle}</Button>
        </DialogTrigger>
      )}
      <DialogContent className="p-8 bg-white">
        <Button
          className="absolute end-2 top-2 h-8 w-8 p-0 border-none !bg-transparent"
          onClick={onClose}>
          <X className="w-5 h-5" color="#DFE3E8" />
        </Button>
        <DialogHeader>
          <DialogTitle className={`${modalTitleStyle} text-start`}>
            {modalTitle}
          </DialogTitle>
          {children}
          <DialogDescription />
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
}
